(ns hypnos.consumer.panels.consult.done
  "The consult done/thank you step."
  (:require [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; fields

(defn- thank-you-message
  [consult]
  [:article.message.is-info
   [:div.message-body
    [:p (tr :ui.thank-you/consult)]
    [:p (tr :ui.thank-you/contact (:consult/service-type consult))]]])

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; step

(defn step
  "The done/thank you step"
  []
  (let [consult (rf/subscribe [:consumer/consult])]
    [:div.card-content
    ;; message
    [thank-you-message @consult]]))
